import { Container } from "react-bootstrap";
import banner from "../assets/images/bannerImg.png";
import device from "../assets/images/main.png";
import searchTrackBase from "../assets/images/png-2.png";
import searchTrack from "../assets/images/search-track.png";
import filmcrewindia from "../assets/images/filmcrewindia.png";
import sched from "../assets/images/sched.png";
import streamline from "../assets/images/streamline.png";
import streamlineBase from "../assets/images/png-3.png";
import pro from "../assets/images/pro.png";
import createManage from "../assets/images/createManage.png";
import createManageBase from "../assets/images/png-4.png";
import aboutUs from "../assets/images/png-1.png";
import { FaApple } from "react-icons/fa";
import { BsAndroid2 } from "react-icons/bs";

const Main = () => {
  return (
    <>
      <section className="hero-wrapper" id="home">
        <img src={banner} alt="banner" className="hero-bg-shape" />

        <Container fluid className="section-container content-wrapper">
          <div className="hero-flex">
            <div className="text-section">
              <h2>The Future of Production Management</h2>
              <p>Simple, Connected, and Intelligent</p>
            </div>

            <div>
              <img src={device} alt="device" />
            </div>
          </div>
        </Container>
      </section>

      <section className="info-section" id="products">
        <img src={searchTrackBase} alt="base" className="base-img" />

        <Container fluid className="section-container">
          <div className="info-flex">
            <div className="info-images">
              <img src={searchTrack} alt="main" className="main-img" />
              <h3 className="left-title">Search, Track & Connect</h3>
            </div>

            <div className="info-content">
              <img src={filmcrewindia} alt="logo" className="fci-logo" />

              <p>
                FilmCrewIndia is your go-to hub for the Indian Entertainment &
                Media industry, helping professionals manage projects, discover
                talent, and connect with vendors seamlessly, along with updates
                of Unions & Associations and information on State & Government
                policies.
              </p>

              <div className="info-buttons">
                <button className="btn btn-know">
                  <a
                    href="https://www.filmcrewindia.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "inherit", textDecoration: "none" }}
                  >
                    Know More
                  </a>
                </button>
                <button className="btn btn-download">
                  <a
                    href="https://apps.apple.com/in/app/film-crew-lite/id6680191631"
                    target="_blank"
                    className="d-flex align-items-center gap-2"
                  >
                    <FaApple size={25} />
                    Download
                  </a>
                </button>

                <button className="btn btn-download">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.pictureCompany.fclite"
                    target="_blank"
                    className="d-flex align-items-center gap-2"
                  >
                    <BsAndroid2 size={25} />
                    Download
                  </a>
                </button>
              </div>
            </div>
          </div>
        </Container>
      </section>

      <section className="streamline-section">
        <Container fluid className="section-container">
          <div className="streamline-flex">
            <div className="info-content">
              {/* <img src={sched} alt="logo" className="fcSched-logo" /> */}
              <img src={pro} alt="logo" className="fcPro-logo" />

              <p>
                FC Pro is a cloud-based scheduling and workflow management tool
                designed to bring clarity and control to every production. It
                turns complex schedules into smooth, coordinated processes,
                allowing teams to track progress in real time, manage tasks, and
                coordinate across departments. From pre-production planning to
                wrap, FC Pro ensures seamless communication, reduces errors, and
                keeps productions running efficiently.
              </p>

              <div className="info-buttons">
                <button className="btn btn-know">
                  <a
                    href="https://www.myfcpro.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "inherit", textDecoration: "none" }}
                  >
                    Know More
                  </a>
                </button>
                <button className="btn btn-download d-flex align-items-center">
                  <FaApple size={25} />
                  Download
                </button>

                <button className="btn btn-download d-flex align-items-center">
                  <BsAndroid2 size={25} />
                  Download
                </button>
              </div>
            </div>
            <div className="info-images">
              <img src={streamline} alt="main" className="main-img" />
              <h3 className="left-title">Streamline Your Project</h3>
            </div>
          </div>
        </Container>
        <img src={streamlineBase} alt="base" className="streamlineBase-img" />
      </section>

      <section className="info-section">
        <Container fluid className="section-container">
          <div className="info-flex">
            <div className="create-images">
              <img
                src={createManageBase}
                alt="base"
                className="createBase-img"
              />
              <img src={createManage} alt="main" className="createMain-img" />

              <h3 className="left-title">You create, We manage</h3>
            </div>

            <div className="info-content">
              <img src={pro} alt="logo" className="fcPro-logo" />

              <p>
                FC Pro is a cloud-based, ultimate Scheduling & Management tool
                for films, OTT, Documentaries, Short films, Vertical
                micro-dramas, Television, and Advertising projects. FC Pro .
                simplifies multiple chaotic pre-production processes on a single
                platform. From creating stripboards to modifying schedules, cast
                & crew management to sharing call sheets, editing breakdowns,
                sharing documents, assigning tasks, updating requirements, and
                much more.
              </p>

              <div className="info-buttons">
                <button className="btn btn-know">
                  <a
                    href="https://www.myfcpro.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "inherit", textDecoration: "none" }}
                  >
                    Know More
                  </a>
                </button>
                <button className="btn btn-download d-flex align-items-center">
                  <FaApple size={25} />
                  Download
                </button>
                <button className="btn btn-download d-flex align-items-center">
                  <BsAndroid2 size={25} />
                  Download
                </button>
              </div>
            </div>
          </div>
        </Container>
      </section>

      <section className="about-section" id="about">
        <img src={aboutUs} alt="About Us" className="about-us-img" />
        <Container fluid className="section-container">
          <div className="about-content">
            <h1>About Us</h1>
            <p className="mt-3">
              FCi Techlabs Pvt. Ltd. is a tech-driven startup revolutionizing
              the entertainment and media industry. We combine deep industry
              insights with innovative digital solutions to streamline how film,
              OTT, and television projects are planned, managed, and executed.
              Our tools simplify complex workflows, turning chaos into
              organized, trackable processes. We help productions manage
              timelines, budgets, scripts, and resources efficiently. By
              connecting creative teams, crew, talent, and vendors on a single
              platform, we make collaboration seamless across locations and
              departments. Real-time updates and intelligent reporting allow
              faster, smarter decision-making at every stage. Our mission is to
              make every production more organized, efficient, and transparent,
              empowering creators to bring their visions to life.
            </p>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Main;
